module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FMTitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "PREF"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#PREF"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ABBR"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviation#ABBR"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "INTRO"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "INTRO.1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1"
    }
  }, [_vm._v("A Canonical Approach to the Pastoral Epistles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.1.1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1.1"
    }
  }, [_vm._v("Texts as “Treasures in Earthen Vessels”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.1.2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1.2"
    }
  }, [_vm._v("The Pauline Authorship of the Pastoral Epistles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.1.3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1.3"
    }
  }, [_vm._v("The Occasion of the Pastoral Epistles as Apostolic Letters of Succession")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.1.4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1.4"
    }
  }, [_vm._v("The Literary Form of the Pastoral Epistles as Letters of Succession")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.1.5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.1.5"
    }
  }, [_vm._v("The Social World of Paul’s Urban Congregations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "INTRO.2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.2"
    }
  }, [_vm._v("The Canonization of the Pauline Letter Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.2.1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.2.1"
    }
  }, [_vm._v("The Formation of the Pauline Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.2.2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.2.2"
    }
  }, [_vm._v("The Final Form of the Pauline Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.2.3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.2.3"
    }
  }, [_vm._v("The Theological Contribution of the Pastoral Epistles to the Pauline Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "INTRO.2.7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.2.7"
    }
  }, [_vm._v("The Hermeneutical Role of the Pastoral Epistles within the Pauline Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "INTRO.3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.3"
    }
  }, [_vm._v("Reading the Pastoral Epistles with the Acts of the Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "INTRO.4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.4"
    }
  }, [_vm._v("The Rule of Faith in Theological Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "INTRO.5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#INTRO.5"
    }
  }, [_vm._v("Three Cases in Point")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "BIB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "BIBLIO.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#BIBLIO.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentaries on the Pastoral Epistles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "BIBLIO.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#BIBLIO.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Works on the Pastoral Epistles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "BIBLIO.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#BIBLIO.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works on Canonical and Rule of Faith Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "CH1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 TIMOTHY")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1–2 Paul Greets Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:3–11 The Aim and Manner of Christian Instruction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:12–17 Paul Thanks God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:18–20 Paul Repeats His Charge to Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:1–7 Instructions regarding Congregational Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:8–3:1a Worship Practices of Christian Men and Women")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1b–7 Profiles in Leadership: Household Administrator")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:8–13 Profiles in Leadership: Household Servants")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:14–4:7a Profiles in Leadership: The Household of God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:7b–16 Paul Charges Timothy to Serve Only Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:1–16 Caring for Widows")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:17–25 Care of Elderly Men")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:1–2a The Conduct of Christian Slaves")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:2b–10 False Teachers")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:11–16 Charge to Remain Faithful to Christ Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:17–19 Final Instructions for the Congregation’s Wealthy Communicants")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH1.17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#CH1.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:20–21 Concluding Benediction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rule of Faith Reading of 1 Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s2-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Creator God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s2-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ Jesus the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s2-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Community of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s2-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Existence and Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s2-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consummation in a New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY")]), _vm._v(": J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESLEY AND THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETHODIST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCIETIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "CH2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 TIMOTHY")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1–2 Paul Greets Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:3–7 Paul Thanks God for Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:8–14 Unashamed of a Sacred Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:15–18 The Example of Onesiphorus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:1–3a A Faithful Succession")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:3b–7 Three Examples of Suffering")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:8–13 Suffering as a Resurrection Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:14–26 True and False Teachers")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:1–9 The Last Days")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:10–4:5 Prepared for Every Good Work")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "CH2.10.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.10.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCURSUS")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPTUAGINT AS THE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LD")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESTAMENT")]), _vm._v("?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:6–8 Paul’s Death Is at Hand")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH2.13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#CH2.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:9–22 Final Instructions, Greetings, and Benediction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rule of Faith Reading of 2 Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s5-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Creator God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s5-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ Jesus the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s5-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Community of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s5-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Existence and Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "CH2.14.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#CH2.14.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCURSUS")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORMATION OF A FAITHFUL CHURCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s5-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s5-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consummation in a New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY")]), _vm._v(": J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLIAM")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LETCHER")]), _vm._v(": J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESLEY’S")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESIGNATED")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UCCESSOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "CH3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TITUS")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:1–4 Paul Greets Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:5–9 A Qualified Elder")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1:10–2:1 A Defiled Opposition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:2–10 A Healthy Household")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:11–14 Salvation’s Appearance")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2:15–3:8c Salvation’s Bath")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "CH3.6.1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XCURSUS")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANONICAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFECT")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("F")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITUS")]), _vm._v(" 3:5B–6")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "CH3.8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#CH3.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3:8d–15 Final Instructions, Greetings, and Benediction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Rule of Faith Reading of Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s8-1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Creator God")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s8-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christ Jesus the Lord")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s8-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Community of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s8-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christian Existence and Discipleship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s8-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consummation in a New Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toca",
    attrs: {
      "id": "s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUDY")]), _vm._v(": P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOEBE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALMER")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESLEYAN")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLINESS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVEMENT")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture References")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0